import cn from 'classnames';
import React from 'react';

import {ButtonRaw} from '@/components/Button';
import {SelectedIcon} from '@/components/Icons';
import {LANGUAGE_SELECT_TITLE_ID} from '@/components/LanguageSelect/consts/languageSelectConsts';
import helpers from '@/utils/helpers';
import {twx} from '@/utils/tailwindUtils';

const LanguageSelectContentSelectList = ({className, data = [], selectedValue, onChange, isDesktopView}) => {
    const handleClick = (languageCode) => {
        helpers.runFunction(onChange, languageCode);
    };

    return (
        <div
            className={cn('flex w-full flex-col rounded-xl bg-primary-dark-5 px-4 ml:px-6 ml:py-2', className)}
            role='listbox'
            aria-labelledby={LANGUAGE_SELECT_TITLE_ID}
        >
            {data.map((item) => {
                const {title, value} = item;
                const isSelected = selectedValue === value;

                return (
                    <ButtonRaw
                        key={value}
                        className={twx(
                            'flex w-full items-center justify-between border-0 border-b border-solid border-primary-dark-15 py-4 last:border-b-0',
                            {
                                'font-bold': isSelected && !isDesktopView,
                            }
                        )}
                        role='option'
                        aria-label={title}
                        aria-selected={isSelected}
                        onClick={() => handleClick(value)}
                    >
                        <div className='flex-1 text-left text-16'>{title}</div>
                        {isSelected && <SelectedIcon />}
                    </ButtonRaw>
                );
            })}
        </div>
    );
};

export default LanguageSelectContentSelectList;
